Namespace 'Customer.Filters'

class Customer.Filters.DateFilter extends Backbone.View
  template: JST['backbone/templates/customer/filters/components/date_filter']
  className: 'd-flex align-items-center align-middle checkboxes'

  events:
    'click #date-range-use': '_onDateRangeUse'
    'click #date-range-to-limit': '_onDateRangeToLimit'

  initialize: ({dateRange}) ->
    @dateRange = dateRange

  render: ->
    @$el.html @template
    @_initializeDatePicker()
    @_setDatepickersInitialStates()
    @

  getDateRange: =>
    from = null
    to = null

    if @_dateRangeUseIsChecked()
      from = @_datepickerFromEl().datepicker().data('datepicker').getDate().toISOString()
      if @_dateRangeToLimitIsChecked()
        to = @_datepickerToEl().datepicker().data('datepicker').getDate().toISOString()

    {from, to}

  _initializeDatePicker: ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)

    fromDate = if @dateRange.from? then new Date(@dateRange.from) else new Date()
    toDate = if @dateRange.to? then new Date(@dateRange.to) else fromDate

    # Existing filters whose stored dates predate the 3-year window are rendered
    # without the lower-bound restriction, so their original dates remain valid.
    datepickerOptions = {todayBtn: 'linked', autoclose: true, enableOnReadonly: false}
    datepickerOptions.startDate = threeYearsAgo unless fromDate < threeYearsAgo or toDate < threeYearsAgo
    @$el.find('.datepicker').datepicker(datepickerOptions)

    @_datepickerFromEl().datepicker('update', fromDate.format('DD-MM-YYYY'))
    @_datepickerToEl().datepicker('update',  toDate.format('DD-MM-YYYY'))

    @_datepickerFromEl().on('changeDate', @_onDatepickerFromChangeDate)
    @_datepickerToEl().on('changeDate', @_onDatepickerToChangeDate)

  _setDatepickersInitialStates: ->
    useFilter = @dateRange.from?
    toLimit = @dateRange.to?
    @_dateRangeUseEl().prop('checked', useFilter)
    @_dateRangeToLimitEl()
      .prop('disabled', not useFilter)
      .prop('checked', toLimit)

    if !useFilter
      @_toggleDatepickerDisabled(@$el.find('.datepicker input'), true)
    else if !toLimit
      @_toggleDatepickerDisabled(@_datepickerToEl().find('input'), true)

  _onDateRangeUse: (event) ->
    @_keepCustomerSessionAlive()
    switchedOn = $(event.target).is(':checked')
    @_dateRangeToLimitEl().prop('disabled', not switchedOn)
    if switchedOn
      if @_dateRangeToLimitIsChecked()
        @_toggleDatepickerDisabled(@$el.find('.datepicker input'), false)
      else
        @_toggleDatepickerDisabled(@_datepickerFromEl().find('input'), false)
    else
      @_toggleDatepickerDisabled(@$el.find('.datepicker input'), true)

  _onDateRangeToLimit: (event) ->
    @_keepCustomerSessionAlive()
    if @_dateRangeUseIsChecked()
      @_toggleDatepickerDisabled(@_datepickerToEl().find('input'), !($(event.target).is(':checked')))

  _onDatepickerFromChangeDate: (event) =>
    datePickerTo = @_datepickerToEl().datepicker().data('datepicker')
    newDate = new Date(event.date)
    if newDate && (datePickerTo.getDate() < newDate || datePickerTo.getDate().getMonth() != newDate.getMonth())
      @_datepickerToEl().datepicker('update', newDate)

  _onDatepickerToChangeDate: (event) =>
    datePickerFrom = @_datepickerFromEl().datepicker().data('datepicker')
    newDate = new Date(event.date)
    if datePickerFrom.getDate() > newDate
      @_datepickerFromEl().datepicker('update', newDate)

  _datepickerFromEl: ->
    @$el.find('.datepicker.from')

  _datepickerToEl: ->
    @$el.find('.datepicker.to')

  _dateRangeUseEl: ->
    @$el.find('#date-range-use')

  _dateRangeToLimitEl: ->
    @$el.find('#date-range-to-limit')

  _dateRangeUseIsChecked: ->
    @_dateRangeUseEl().is(':checked')

  _dateRangeToLimitIsChecked: ->
    @_dateRangeToLimitEl().is(':checked')

  _toggleDatepickerDisabled: (element, isDisabled) ->
    element.prop('disabled', isDisabled).prop('readonly', isDisabled)

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'
